var _path, _path2, _g, _path3, _g2, _path4, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 134,
    viewBox: "0 0 430 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.52 71.24C368.52 79.61 361.01 83.58 347.59 86.27C345.76 76.83 351.02 64.37 360.15 64.37C363.91 64.37 368.52 66.62 368.52 71.24ZM383.76 71.45C383.76 59.54 370.66 55.46 361.22 55.46C342.44 55.46 332.88 68.34 332.88 84.55C332.88 102.8 344.58 113.53 361.11 113.53C368.84 113.53 375.49 111.38 381.18 106.77C380.64 105.27 379.35 100.98 377.64 98.83C371.74 103.66 367.55 104.73 362.83 104.73C353.6 104.73 350.27 98.08 348.66 93.25C364.76 90.57 383.76 83.48 383.76 71.46M312.58 84.33C312.58 94.85 307.11 102.79 299.59 102.79C292.07 102.79 286.71 95.81 286.71 84.33C286.71 72.85 292.18 64.47 299.59 64.47C307 64.47 312.58 72.95 312.58 84.33ZM328.36 57.5H313.55C312.8 59.76 312.16 61.69 312.16 64.05C309.48 59 304.22 55.68 297.24 55.68C284.25 55.68 272.34 66.74 272.34 84.34C272.34 101.94 284.47 111.6 297.24 111.6C302.61 111.6 308.83 109.56 312.16 103.98V111.28C312.16 120.3 305.07 124.8 297.99 124.8C291.44 124.8 285.43 122.12 281.89 119.43C280.28 121.36 278.67 125.55 278.35 127.27C285.22 131.78 292.95 133.92 300.68 133.92C310.98 133.92 326.22 127.7 326.22 110.52V72.42C326.22 66.3 327.51 59.54 328.37 57.5M252.28 88.2C252.28 97.86 244.88 104.62 237.36 104.62C232.96 104.62 231.03 101.72 231.03 97.97C231.03 94 232.1 88.31 240.37 85.52C242.95 84.66 248.85 81.66 252.28 79.62V88.21V88.2ZM268.59 111.38C266.98 106.98 265.8 99.79 265.8 96.25V76.07C265.8 59.54 253.89 55.68 243.58 55.68C235.85 55.68 226.3 57.72 219.54 62.23C219.86 63.95 221.47 68.13 223.08 70.17C226.62 67.38 232.63 64.7 239.18 64.7C246.26 64.7 250.45 66.63 250.66 71.03C250.77 73.71 247.33 75.65 241.32 77.36C224.26 82.19 217.06 89.7 217.06 100.44C217.06 107.2 222.64 113.43 231.01 113.43C237.66 113.43 245.07 113.43 252.26 102.8C252.26 104.95 253.23 109.35 254.08 111.39H268.57L268.59 111.38ZM214.82 107.41C213.96 105.48 211.92 102.69 210.1 101.08C208.81 102.04 206.99 104.3 203.02 104.3C199.05 104.3 197.12 99.79 197.12 96.04V66.52H210.7C211.99 64.91 213.28 60.19 213.6 57.5H197.12V37.86C192.72 38.5 187.14 40.33 183.06 43.66V92.71C183.06 102.59 186.92 113.21 199.48 113.21C207.21 113.21 211.93 110.31 214.83 107.41M179.51 111.38L160.19 85.94C159.23 84.76 159.33 83.26 160.19 82.08L178.33 57.5H162.55L151.06 75.1L139.36 57.5H124.55L142.15 81.86C143.12 83.36 143.01 84.97 142.26 85.94L123.05 111.38H139.15L151.17 93.13L164.05 111.38H179.51ZM106.84 71.24C106.84 79.61 99.33 83.58 85.91 86.27C84.09 76.83 89.35 64.37 98.47 64.37C102.23 64.37 106.84 66.62 106.84 71.24ZM122.08 71.45C122.08 59.54 108.98 55.46 99.54 55.46C80.76 55.46 71.2 68.34 71.2 84.55C71.2 102.8 82.9 113.53 99.43 113.53C107.16 113.53 113.81 111.38 119.5 106.77C118.96 105.27 117.67 100.98 115.96 98.83C110.06 103.66 105.87 104.73 101.15 104.73C91.92 104.73 88.59 98.08 86.98 93.25C103.08 90.57 122.08 83.48 122.08 71.46M64.51 100.22V37.86H50.24V98.93C50.24 100.43 48.95 101.29 47.98 98.93L26.08 46.44C23.08 39.25 18.14 37.85 11.16 37.85C4.18 37.85 0 42.04 0 49.13V111.39H14.28V50.31C14.28 48.81 15.57 47.95 16.53 50.31L38.43 102.8C41.33 109.88 45.51 111.39 52.49 111.39C59.47 111.39 64.51 107.2 64.51 100.23",
    fill: "#45576D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3627_1992",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 385,
    y: 0,
    width: 45,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.31 21.87C385.31 33.94 395.1 43.73 407.17 43.73C419.24 43.73 429.03 33.94 429.03 21.87C429.03 9.80001 419.24 0.0100098 407.17 0.0100098C395.1 0.0100098 385.31 9.80001 385.31 21.87Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3627_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.571 -18.0076L367.303 9.46875L394.779 61.7369L447.047 34.2606L419.571 -18.0076Z",
    fill: "url(#paint0_linear_3627_1992)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3627_1992",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 345,
    y: 7,
    width: 30,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.83 21.87C345.83 29.68 352.16 36.01 359.97 36.01C367.78 36.01 374.11 29.68 374.11 21.87C374.11 14.06 367.78 7.72998 359.97 7.72998C352.16 7.72998 345.83 14.06 345.83 21.87Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3627_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.713 -4.6861L333.406 15.0981L353.19 48.4054L386.498 28.6211L366.713 -4.6861Z",
    fill: "url(#paint1_linear_3627_1992)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3627_1992",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 13,
    width: 18,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M317.27 21.8699C317.27 26.6599 321.15 30.54 325.94 30.54C330.73 30.54 334.61 26.6599 334.61 21.8699C334.61 17.0799 330.73 13.2 325.94 13.2C321.15 13.2 317.27 17.0799 317.27 21.8699Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3627_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.436 5.7786L309.85 17.3594L321.43 37.9455L342.017 26.3648L330.436 5.7786Z",
    fill: "url(#paint2_linear_3627_1992)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3627_1992",
    x1: 420.675,
    y1: 13.1755,
    x2: 388.192,
    y2: 30.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F38726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8663E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E2524C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E04B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3627_1992",
    x1: 387.867,
    y1: 8.02321,
    x2: 343.965,
    y2: 34.1008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FB9F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E76240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E04B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B50F1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3627_1992",
    x1: 336.429,
    y1: 14.4955,
    x2: 319.531,
    y2: 24.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E04B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DE484F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D73F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CD3039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BE1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B50F1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.643e091abb300b83bcb2f254708591c9.svg";
export { ForwardRef as ReactComponent };